import { object, string } from "superstruct";

const BaseCoRegistrantSchema = object({
    firstName: string(),
    lastName: string(),
});

export default BaseCoRegistrantSchema;
